import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-500" data-testid="loading-state">Loading...</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role) && user.role !== "admin" && user.role !== "service_head") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center" data-testid="forbidden-state">
          <div className="text-2xl font-heading font-bold text-slate-900">Access denied</div>
          <div className="text-sm text-slate-500 mt-2">You do not have permission to view this page.</div>
        </div>
      </div>
    );
  }
  return children;
}
